module.exports = __webpack_public_path__ + "static/media/red_x.e7cf0bb7.svg";